import { Component, Inject } from '@angular/core';

@Component({
    selector: 'paypal-failure',
    templateUrl: './paypal-failure.component.html'
})
export class PayPalFailureComponent {
}

